<template lang="pug">
  e-chart(
    :header="`${documentTitle}, ${measure}`"
    :options="chartDynamicOptions"
    :series="chartDynamicSeries"
    chartId="dynamic"
    ref="chart"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
  )
    template(slot="exportData")
      .chart-block__export-data
        div {{documentTitle}}, {{measure}}
        div Показатель: {{fields.dynamicTypeTmpName}}
        div Период: {{dynamicTypePeriodOptions.find(item=>item.id===fields.dynamicTypePeriod).name }}
    template(slot="chartHeader")
      .default-select.part-3-from-4.chart-block__wide-select
        button.button.button_gray.chart-block__name(
          :title="fields.dynamicTypeTmpName"
          @click.stop="showDynamicTypes = !showDynamicTypes"
        ) {{fields.dynamicTypeTmpName}}
        div.filter-popup(
          v-if="showDynamicTypes"
          style="left:0"
          @click.stop=""
        )
          e-perfect-scrollbar
            ul.reset-list
              li.filter-popup__item(v-for="item in chartDynamicTypeOptions" :key="'dynamic-' + item.id")
                input.visually-hidden(type="radio" v-model="fields.dynamicType" name="dynamic" @change="changeDynamic" :data-name="item.name" :value="item.id" :id="'dynamic-' + item.id")
                label.label.custom-checkbox__label(:for="'dynamic-' +  item.id")
                  span.custom-checkbox__text {{ item.name }}
      .default-select.part-1-from-4(style='min-width: 100px')
        e-select(
          class="dropdown-btn"
          tabView="tab1"
          :model="fields"
          placeholder="Период"
          name="dynamicTypePeriod"
          :options="dynamicTypePeriodOptions"
        )
</template>

<script>
import { indicator } from '@/api/api-endpoints'
import yearHandler from '@/utils/year'
import chartsMixin from '../mixins/charts-mixin'

export default {
  mixins: [chartsMixin],
  data() {
    return {
      measure: '%',
      showDynamicTypes: false,
    }
  },
  computed: {
    viewMode: {
      get: function () {
        return this.$store.getters.charts.dynamic.viewMode
      },
      set: function (newValue) {
        this.$store.commit('charts', { dynamic: { viewMode: newValue } })
      },
    },
    getCurrentChartOptions() {
      return this.getChartOptions('dynamic')
    },
  },
  watch: {
    'fields.dynamic.viewMode': {
      handler: function (v) {
        this.viewMode = v
        this.fetchData()
      },
    },
    'fields.dynamicType': 'fetchIndicators',
    'fields.dynamicTypePeriod': 'fetchIndicators',
  },
  methods: {
    changeDynamic(e) {
      this.showDynamicTypes = false
      this.fields.dynamicTypeTmpName = e.target.dataset.name
    },
    onDynamicTypePeriod() {
      const endpoint = this.buildEndpoint()
      let r = {
        data: this.$store.getters.readUrlEndpoint(endpoint) || {},
      }
      if (r) {
        this.chartDynamicSeries = this.transform(r)
        this.createAndSetCats(r, this.chartDynamicSeries)
      }
      this.fetchIndicators()
    },
    getYearPeriod() {
      return this.fields.dynamicTypePeriod
        ? {
            startYear: yearHandler.getCurrentYear(),
            endYear:
              yearHandler.getCurrentYear() + this.fields.dynamicTypePeriod - 1,
          }
        : null
    },
    buildEndpoint() {
      return this.getEndpoint()({
        query: {
          type: 'cp',
          cp_id: this.fields.dynamicType,
          viewMode: this.viewMode,
        },
      })
    },
    fetchIndicators() {
      this.loading = true
      return this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint: indicator.objects({ query: { 'per-page': -1 } }),
          params: { disableGlobalError: true },
        })
        .then((r) => {
          if (r.data.data) {
            this.chartDynamicTypeOptions = r.data.data
            // set first option on init
            if (this.fields.dynamicType === null) {
              let defaultOption = this.chartDynamicTypeOptions[0]
              this.fields.dynamicType = defaultOption.id
              this.fields.dynamicTypeTmpName = defaultOption.name
              this.loading = false
            } else {
              this.fetchData()
            }
          }
          return r
        })
        .catch((e) => {
          this.chartError = e
          return e
        })
        .finally(() => (this.loading = false))
    },
    fetchData() {
      this.fetchChartData().then((r) => {
        this.chartDynamicSeries = r.data.data ? this.transform(r.data.data) : []
        this.createAndSetCats()
      })
    },
    transform({ measure, series = [] }) {
      if (!series.length) {
        return []
      }

      this.measure = measure || this.measure
      let years = this.getYearPeriod()

      this.pointStart = yearHandler.getCurrentYear()

      // series have special fill colors options
      let newSeries = []
      let defaultSeries = this.getChartSeries('dynamic')
      for (let i = 0, c = series.length; i < c; i++) {
        newSeries[i] = { data: [] }
        for (let j = 0, cj = series[i].data.length; j < cj; j++) {
          let year = this.pointStart + j
          let yearIsIncorrect =
            years?.endYear && (year < years.startYear || year > years.endYear)
          if (yearIsIncorrect) {
            continue
          }
          newSeries[i].data.push(+series[i].data[j] || null)
        }
        newSeries[i] = Object.assign(defaultSeries[i], newSeries[i])
      }
      return newSeries
    },
    createAndSetCats() {
      let options = Object.assign({}, this.chartDynamicOptions)
      options.plotOptions.area.pointStart = this.pointStart || 2000
      this.chartDynamicOptions = options
      this.$refs.chart.drawChart()
    },
    outerClick() {
      this.showDynamicTypes = false
    },
  },
  created() {
    this.pointStart = 0
    this.chartDynamicOptions = this.getCurrentChartOptions
    this.fetchIndicators()
    window.addEventListener('click', this.outerClick)
  },
}
</script>
